import { t } from "@/i18n-js/instance";
import { FeatureRow } from "../FeatureRow";
import { SectionWrapper } from "./SectionWrapper";

export const CommunityAi = () => (
  <SectionWrapper sectionName={t("pricing_plans.section.community_ai")}>
    <FeatureRow
      title={t("pricing_plans.feature.content_co_pilot")}
      basic={false}
      professional={false}
      business
      enterprise
    />

    <FeatureRow
      title={t("pricing_plans.feature.automated_transcriptions")}
      basic={false}
      professional={false}
      business
      enterprise
    />

    <FeatureRow
      title={t("pricing_plans.feature.activity_scores")}
      basic={false}
      professional={false}
      business
      enterprise
    />
  </SectionWrapper>
);
